export default __webpack_public_path__ + "static/media/lines-plaque.28ccb08e.png";